import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { Box, Button } from '@material-ui/core';
import { BaseModal } from 'components/UI';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useHistory } from 'react-router-dom';
import { buildUrl } from 'utils';

const CancelSuccess = ({ open, handleClick, id }) => {
  const history = useHistory();

  return (
    <BaseModal
      size="sm"
      open={open}
      hasEnterButton
      enableCloseButton={false}
      handleClick={handleClick}
      onEnter={handleClick}
      enterButtonLabel={i18n.t('common.continue')}
      title={
        <>
          <CheckCircleIcon
            style={{
              color: '#00A393',
              marginRight: 5,
            }}
          />
          {i18n.t('subscriptions.successfully_canceled')}
        </>
      }
    >
      <Box width="100%">
        <span>{i18n.t('subscriptions.successfully_canceled_msg')}</span>
        <Button
          type="button"
          variant="text"
          color="primary"
          style={{
            textTransform: 'capitalize',
            padding: 0,
            minWidth: 'auto',
          }}
          disableFocusRipple={true}
          onClick={() => {
            history.push(buildUrl(`/invoices?source_id=${id}&source_name=Subscription`));
          }}
        >
          {i18n.t('subscriptions.refund')}
        </Button>
      </Box>
    </BaseModal>
  );
};

CancelSuccess.propTypes = {
  id: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};

CancelSuccess.defaultProps = {
  open: false,
  handleClick: () => {},
};

export default CancelSuccess;
